import { Box, Button, Grid, Typography } from '@mui/material';
import MuiTextField3 from '@/components/TextField3';
import Image from 'next/image';
import { UseIntermitence } from '@/hooks';
import { palette } from '@/theme/constants';

const EmailPasswordStep = ({ formik, onNext }: any) => {
  const { values, handleSubmit, handleChange, errors, touched, setFieldTouched, validateField } = formik;
  const { status: showPassword, switchStatus: switchShowPassword } = UseIntermitence();
  const { status: showConfirmPassword, switchStatus: switchShowConfirmPassword } = UseIntermitence();
  const handleBlur = (field: string) => {
    setFieldTouched(field, true);
    validateField(field);
  };
  const handleNextStep = () => {
    if (
      !errors.email &&
      !errors.password &&
      !errors.confirm_password &&
      !errors?.is13OrOlder &&
      !errors?.acceptedTerms
    ) {
      onNext();
    }
  };
  const hasErrors =
    (!!errors.email && touched.email) ||
    values.email === '' ||
    (!!errors.password && touched.password) ||
    values.password === '' ||
    (!!errors.confirm_password && touched.confirm_password) ||
    values.confirm_password === '' ||
    !values.is13OrOlder ||
    !values.acceptedTerms;

  return (
    <Box width='100%' maxWidth='33rem' textAlign='center'>
      <Box mb={2}>
        <Image priority src='/images/logo-new.svg' width={66} height={34} alt='memvy' />
      </Box>
      <Typography mb={'1.25rem'} color='black' fontSize='1.5rem'>
        Sign up
      </Typography>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
        <Grid container width='100%' rowSpacing={2}>
          <Grid item xs={12} mb={'1.25rem'}>
            <Typography align='left' color={palette?.background} mb={'0.5rem'} fontSize={'1rem'}>
              Email Address
            </Typography>
            <MuiTextField3
              id='email'
              name='email'
              fullWidth
              required
              onBlur={() => handleBlur('email')}
              onChange={handleChange}
              value={values.email}
              autoComplete='email'
              placeholder='Enter your email'
              error={Boolean(errors.email && touched.email)}
              errorMessage={errors.email}
            />
          </Grid>

          <Grid item xs={12} mb={'1.25rem'}>
            <Typography align='left' color={palette?.background} mb={'0.5rem'} fontSize={'1rem'}>
              Password
            </Typography>
            <MuiTextField3
              id='password'
              name='password'
              type={showPassword ? 'text' : 'password'}
              fullWidth
              required
              placeholder='Enter a password'
              onBlur={() => handleBlur('password')}
              onChange={handleChange}
              value={values.password}
              error={Boolean(errors.password && touched.password)}
              errorMessage={errors.password}
              iconMethod={switchShowPassword}
              iconHeight={24}
              iconWidth={24}
              endIcon={showPassword ? '/icons/eye-blue.svg' : '/icons/eye-light.svg'}
            />
            <Typography align='left' color='#5C6372' fontSize={'0.8rem'}>
              Must contain at least 10 characters.
            </Typography>
          </Grid>

          <Grid item xs={12} mb={'1.25rem'}>
            <Typography align='left' color={palette?.background} mb={'0.5rem'} fontSize={'1rem'}>
              Confirm Password
            </Typography>
            <MuiTextField3
              id='confirm_password'
              name='confirm_password'
              fullWidth
              placeholder='Enter a password'
              required
              onBlur={() => handleBlur('confirm_password')}
              iconMethod={switchShowConfirmPassword}
              iconHeight={24}
              iconWidth={24}
              type={!showConfirmPassword ? 'password' : 'text'}
              endIcon={showConfirmPassword ? '/icons/eye-blue.svg' : '/icons/eye-light.svg'}
              onChange={handleChange}
              value={values.confirm_password}
              error={Boolean(errors.confirm_password && touched.confirm_password)}
              errorMessage={errors.confirm_password}
            />
          </Grid>
          <Grid item xs={12}>
            <Box display='flex' alignItems='flex-start'>
              <input
                type='checkbox'
                id='is13OrOlder'
                name='is13OrOlder'
                checked={values.is13OrOlder}
                onChange={handleChange}
                onBlur={() => handleBlur('is13OrOlder')}
                style={{ marginRight: '0.5rem', marginTop: '0.2rem' }}
              />
              <Typography fontSize='0.9rem' color={palette?.background}>
                I confirm that I am at least 13 years old.
              </Typography>
            </Box>
            {errors.is13OrOlder && touched.is13OrOlder && (
              <Typography align='left' fontSize='0.75rem' color='red'>
                {errors.is13OrOlder}
              </Typography>
            )}
          </Grid>

          <Grid item xs={12}>
            <Box display='flex' alignItems='flex-start'>
              <input
                type='checkbox'
                id='acceptedTerms'
                name='acceptedTerms'
                checked={values.acceptedTerms}
                onChange={handleChange}
                onBlur={() => handleBlur('acceptedTerms')}
                style={{ marginRight: '0.5rem', marginTop: '0.2rem' }}
              />
              <Typography fontSize='0.9rem' color={palette?.background}>
                I agree to the{' '}
                <a href='/terms' target='_blank' style={{ textDecoration: 'underline', color: '#212D6D' }}>
                  Terms and Conditions
                </a>
                .
              </Typography>
            </Box>
            {errors.acceptedTerms && touched.acceptedTerms && (
              <Typography align='left' fontSize='0.75rem' color='red'>
                {errors.acceptedTerms}
              </Typography>
            )}
          </Grid>
        </Grid>

        <Button
          type='submit'
          variant='contained'
          disabled={hasErrors}
          onClick={handleNextStep}
          fullWidth
          sx={{
            '&:disabled': {
              backgroundColor: '#B0B3C0',
              color: '#FFFFFF',
              opacity: 1,
            },
            height: '60px',
            borderRadius: '0.6rem',
            fontSize: '1rem',
            backgroundColor: hasErrors ? '#B0B3C0' : '#212D6D',
            mt: 2,
          }}>
          <Typography mr={2} variant='button'>
            Next
          </Typography>
          <Image priority src='/icons/right-arrow.svg' width={13} height={13} alt='right' />
        </Button>
      </form>
    </Box>
  );
};

export default EmailPasswordStep;
